module.exports = __webpack_public_path__ + "img/ditu@2x.f315985a.png";